import React, { useEffect } from "react";
import { Provider } from "react-redux";
import { useAuth0 } from "@auth0/auth0-react";
import { init as initFullStory } from "@fullstory/browser";
import { useFlags } from "launchdarkly-react-client-sdk";

import { AppRoutes } from "./routes/Routes";
import { store } from "./store/store";
import { securityOptions } from "./shared/config/storeConfig";
import { configs } from "./shared/config/config";
import AllowedRoutesTracker from "./components/AllowedRoutesTracker";
import RexSupportWidget from "./components/RexSupportWidget";
import { IdleSessionGuard } from "./components/IdleSessionGuard/IdleSessionGuard";

function App() {
  const { getAccessTokenSilently, logout, loginWithRedirect } = useAuth0();
  // Auth0 helpers for use outside React (prepareHeaders soft-recover uses loginWithRedirect)
  securityOptions.setAccessTokenSilently(getAccessTokenSilently);
  securityOptions.setLogout(logout);
  securityOptions.setLoginWithRedirect(loginWithRedirect);

  const [fsInitialized, setFsInitialized] = React.useState(false);
  const fsInitRef = React.useRef(false);

  /**
   * Enabled and Disabled Fullstory with the feature flags.
   */
  const { tpEnableFullstoryConfigs } = useFlags();
  useEffect(() => {
    if (!tpEnableFullstoryConfigs || fsInitRef.current) {
      return;
    }
    if (!configs.FULLSTORY_ORG_ID) {
      console.warn("FullStory orgId is missing. Skipping init.");
      return;
    }

    initFullStory({
      orgId: configs.FULLSTORY_ORG_ID,
      recordCrossDomainIFrames: true,
      startCaptureManually: true,
    });
    fsInitRef.current = true;
    setFsInitialized(true);
  }, [tpEnableFullstoryConfigs]);

  return (
    <Provider store={store}>
      <div className="App">
        <AllowedRoutesTracker fsInitialized={fsInitialized} />
        <IdleSessionGuard />
        <AppRoutes />
        <RexSupportWidget />
      </div>
    </Provider>
  );
}

export default App;
